import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { generateFileUploadUrl } from '@wix/ambassador-media-site-media-v1-file-descriptor/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { SiteMediaFilesClientBase } from './SiteMediaFilesClientBase';
export class SiteMediaFilesClient extends HttpBaseClient(SiteMediaFilesClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "generateFileUploadUrlImpl", generateFileUploadUrl);
  }
}
//# sourceMappingURL=SiteMediaFilesClientHttp.js.map